import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseApi } from './base-api.service';
import { map } from 'rxjs/operators';

@Injectable()
export class CommonFieldsService {

  private baseUrl = '/dict';

  private states = [
    { id: "AN", name: 'Andaman & Nicobar Islands' },
    { id: "AP", name: 'Andhra Pradesh' },
    { id: "AR", name: 'Arunachal Pradesh' },
    { id: "AS", name: 'Assam' },
    { id: "BR", name: 'Bihar' },
    { id: "CH", name: 'Chandigarh' },
    { id: "CG", name: 'Chhattisgarh' },
    { id: "DN", name: 'Dadra & Nagar Haveli' },
    { id: "DD", name: 'Daman & Diu' },
    { id: "DL", name: 'Delhi' },
    { id: "GA", name: 'Goa' },
    { id: "GJ", name: 'Gujarat' },
    { id: "HR", name: 'Haryana' },
    { id: "HP", name: 'Himachal Pradesh' },
    { id: "JK", name: 'Jammu & Kashmir' },
    { id: "JH", name: 'Jharkhand' },
    { id: "KA", name: 'Karnataka' },
    { id: "KL", name: 'Kerala' },
    { id: "LD", name: 'Lakshadweep' },
    { id: "MP", name: 'Madhya Pradesh' },
    { id: "MH", name: 'Maharashtra' },
    { id: "MN", name: 'Manipur' },
    { id: "ML", name: 'Meghalaya' },
    { id: "MZ", name: 'Mizoram' },
    { id: "NL", name: 'Nagaland' },
    { id: "OR", name: 'Orissa' },
    { id: "PY", name: 'Pondicherry/Puducherry' },
    { id: "PB", name: 'Punjab' },
    { id: "RJ", name: 'Rajasthan' },
    { id: "SK", name: 'Sikkim' },
    { id: "TN", name: 'Tamil Nadu' },
    { id: "TR", name: 'Tripura' },
    { id: "UP", name: 'Uttar Pradesh' },
    { id: "UL", name: 'Uttaranchal/Uttarakhand' },
    { id: "WB", name: 'West Bengal' },
];

  private accomodTypes = [
    { id: 1, name: 'Self Owned' },
    { id: 2, name: 'Parental' },
    { id: 3, name: 'Relative' },
    { id: 4, name: 'Company Provided' },
    { id: 5, name: 'Rented' },
    { id: 6, name: 'Bachelor Accomodation' },
    { id: 7, name: 'Paying Guest' },
  ];

  private custType = [
    { id: true, name: 'Existing  Customer' },
    { id: false, name: 'New  Customer' },
  ]

  private appliType = [
    { id: true, name: 'Retail Loans' },
    { id: false, name: 'Farmer Loans - KCC' },
  ]

  private companyTypes = [
    { id: 1, name: 'Proprietorship' },
    { id: 2, name: 'Partnership' },
    { id: 3, name: 'Private Limited(Listed)' },
    { id: 4, name: 'Private Limited(MNC)' },
    { id: 5, name: 'Public Sector' },
    { id: 6, name: 'Government' },
  ];

  private empTypes = [
    { id: 1, name: 'Salaried' },
    { id: 2, name: 'Self-Employed Professional' },
    { id: 3, name: 'Self-Employed Other' },
  ];

  private gender = [
    { id: "M", name: 'Male' },
    { id: "F", name: 'Female' },
    { id: "O", name: 'Other' },
  ];

  private manufacturingYears = [
    { id: 1, name: '2017' },
    { id: 2, name: '2016' },
    { id: 3, name: '2015' },
  ];

  private maritalStatus = [
    { id: 1, name: 'Single' },
    { id: 2, name: 'Married' },
  ];

  private professionalTypes = [
    { id: 1, name: 'BE' },
    { id: 2, name: 'BTech' },
    { id: 3, name: 'CA' },
    { id: 4, name: 'ICWA' },
    { id: 5, name: 'ICS' },
    { id: 6, name: 'MBBS' },
    { id: 7, name: 'MS' },
    { id: 8, name: 'MD' },
    { id: 9, name: 'MBA' },
  ];

  private qualificationTypes = [
    { id: 1, name: 'Matriculate' },
    { id: 2, name: 'Undergraduate' },
    { id: 3, name: 'Graduate' },
    { id: 4, name: 'Professional' },
    { id: 5, name: 'Postgraduate' },
    { id: 6, name: 'Doctorate' },
    { id: 7, name: 'Other' },
  ];

  private yearsAtCurrentRes = [
    { id: 1, name: 'Less than 1 Year' },
    { id: 2, name: '1 Year' },
    { id: 3, name: '2 Years' },
    { id: 4, name: '3 Years' },
    { id: 5, name: 'More than 3 Years' },
  ];

  private debtorTypes = [
    { id: "company", name: 'Company' },
    { id: "llp", name: 'LLP' },
    { id: "other", name: 'Other' },
  ];

  private genderId = [
    { id: "M", name: 'Male' },
    { id: "F", name: 'Female' },
    { id: "O", name: 'Other' },
  ];

  private loanTypes = [
    { id: 1, name: 'Home Loan' },
    { id: 2, name: 'SME Loan' },
    { id: 3, name: 'Loan Against Property' },
    { id: 4, name: 'Personal Loan' },
    { id: 5, name: 'Vehicle Loan' },
    { id: 6, name: 'Gold Loan' }
  ];

  private genders = [
    { id: 1, name: 'Male' },
    { id: 2, name: 'Female' },
    { id: 3, name: 'Other' },
  ];

  private crops = [
    {id: 1, name: 'Paddy'},
    {id: 2, name: 'Wheat'},
    {id: 3, name: 'Soyabean'},
    {id: 4, name: 'Jowar'},
    {id: 5, name: 'Others'},
  ];

  private approvalStatus = [
    {id: 'approved', name: 'Approved'},
    {id: 'rejected', name: 'Rejected'},
    {id: 'pending', name: 'Reassigned'}, 
  ];

  private emptyArray = []
 
  
  constructor(
    private api: BaseApi
  ) { }

  getAccomodTypes() {
    return of(this.accomodTypes);
  }

  getCustTypes(){
    return of(this.custType);
  }

  getAppliTypes(){
    return of(this.appliType);
  }

  getGenderEquifax() {
    return of(this.genders); 
  }

  getCustLoanTypes() {
    return of(this.loanTypes);
  }

  getGenderId() {
    return of(this.genderId);
  }

  getBank(id) {
    return this.api.newGet(`${this.baseUrl}/banks/${id}`);
  }

  getBanks() {
    return this.api.newGet(`${this.baseUrl}/banks`);
  }

  getCity(id) {
    return this.api.newGet(`${this.baseUrl}/cities/${id}`);
  }

  getCities() {
    return this.api.newGet(`${this.baseUrl}/cities`);
  }

  getPin(args){
    return this.api.getComplt(`/users/getAddress/${args}`);
  }

  getCompanyTypes() {
    return of(this.companyTypes);
  }

  getEmpType(id) {
    return of(this.empTypes.filter(et => et.id === id)[0].name);
  }

  getEmpTypes() {
    return of(this.empTypes);
  }

  getGender() {
    return of(this.gender);
  }

  getLoanType(id) {
    return this.api.newGet(`${this.baseUrl}/loan-types/${id}`);
  }

  getLoanTypes() {
    return this.api.newGet(`${this.baseUrl}/loan-types`)
      .pipe(map(loanTypes => loanTypes.sort((lta, ltb) => lta.name.toLowerCase() > ltb.name.toLowerCase() ? 1 : -1)));
  }

  getManufacturingYears() {
    return of(this.manufacturingYears);
  }

  getMaritalStatus() {
    return of(this.maritalStatus);
  }

  getProfessionalTypes() {
    return of(this.professionalTypes);
  }

  getDebtorTypes() {
    return of(this.debtorTypes);
  }

  getQualificationTypes() {
    return of(this.qualificationTypes);
  }

  getResidentType(id) {
    return this.api.newGet(`${this.baseUrl}/resident-types/${id}`);
  }

  getResidentTypes() {
    return this.api.newGet(`${this.baseUrl}/resident-types`);
  }

  getState(id) {
    return this.api.newGet(`${this.baseUrl}/states/${id}`);
  }

  getStates() {
    return this.api.newGet(`${this.baseUrl}/states`);
  }
  getRahList() {
    return this.api.newGet(`${this.baseUrl}/rahcode`);
  }

  getYearsAtCurrentRes() {
    return of(this.yearsAtCurrentRes);
  }


  getCropTypes() {
    return of(this.crops);
  }

  getApprovalStatus(){
    return of(this.approvalStatus);
  }

  getcrops() {
    return of(this.crops);
  }

  getTheState(){
    return of(this.states)
  }


}
